import React from 'react'

import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink } from './SidebarElements';

// import "../../assets/css/sidebar.css";

const Sidebar = ({ isOpen, toggle }) => {
    return (
        <>
            <SidebarContainer isOpen={isOpen} onClick={toggle}>
                <Icon onClick={toggle}>
                    <CloseIcon />
                </Icon>
                <SidebarWrapper className="sidebar-wrapper">
                    <SidebarMenu>
                        <SidebarLink to="/" onClick={toggle}>FAQ</SidebarLink>
                        <SidebarLink to="/" onClick={toggle}>Premium</SidebarLink>
                        <SidebarLink to="/landingpage" onClick={toggle}>Landing Page</SidebarLink>
                        <SidebarLink to="/" onClick={toggle}>Join Private Beta</SidebarLink>
                    </SidebarMenu>
                </SidebarWrapper>
            </SidebarContainer>
        </>
    )
}

export default Sidebar;
